import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ChatMessageHistoryService {
  private readonly STORAGE_KEY = 'pointeeMessageHistory';
  private readonly maxSize = 50;
  private history: string[] = [];
  private historyIndex = -1;

  constructor() {
    this.loadFromLocalStorage();
  }

  private loadFromLocalStorage(): void {
    try {
      const storedHistory = localStorage.getItem(this.STORAGE_KEY);
      this.history = storedHistory ? JSON.parse(storedHistory) as string[] : [];
    } catch (e) {
      console.error('Error loading message history from localStorage:', e);
      this.history = [];
    }
  }

  private saveToLocalStorage(): void {
    try {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.history));
    } catch (e) {
      console.error('Error saving message history to localStorage:', e);
    }
  }

  addMessage(message: string): void {
    if (!message || message.trim() === '') return;

    // Don't add duplicates of the most recent message
    if (this.history.length > 0 && this.history[0] === message) {
      return;
    }

    // Add new message to the beginning of the array
    this.history.unshift(message);

    // Keep the history at the maximum size
    if (this.history.length > this.maxSize) {
      this.history.pop();
    }

    this.historyIndex = -1; // Reset the index
    this.saveToLocalStorage();
  }

  getPreviousMessage(): string {
    if (this.history.length === 0) return '';

    this.historyIndex = Math.min(this.historyIndex + 1, this.history.length - 1);
    return this.history[this.historyIndex];
  }

  getNextMessage(): string {
    if (this.history.length === 0 || this.historyIndex <= 0) {
      this.historyIndex = -1;
      return '';
    }

    this.historyIndex--;
    return this.historyIndex === -1 ? '' : this.history[this.historyIndex];
  }

  resetIndex(): void {
    this.historyIndex = -1;
  }
}
